import React, { FC } from 'react';
import { ThemeProvider } from 'styled-components';
import { SRootStyle } from 'students/views/shared/styled';

import theme from '../styled/userVariables';

function withSRootStyle<P extends Record<string, any>>(
  WrappedComponent: React.ComponentType<P>
): FC<P> {
  const hocComponent: FC<P> = ({ ...props }) => (
    <ThemeProvider theme={theme}>
      <SRootStyle>
        <WrappedComponent {...props} />
      </SRootStyle>
    </ThemeProvider>
  );

  return hocComponent;
}

export { theme };

export default withSRootStyle;
